import { useIntl } from '@/intl'
import { useState } from 'react'

export const useTexts = () => {
  const { translate } = useIntl()

  const [api] = useState(() => ({
    mixed: translate({ id: 'order.form.bulk.mixed' }),
    serviceTime: translate({ id: 'orders.edit.field.serviceTime' }),
    invalidServiceTimeFormat: translate({
      id: 'order.form.bulk.field.serviceTimeSec.invalidFormat',
    }),
    invalidServiceTimeMaxValue: translate({
      id: 'order.form.bulk.field.serviceTimeSec.invalidMaxValue',
    }),
  }))

  return api
}

export type Texts = ReturnType<typeof useTexts>
